
import StudentEnquiryForm from '../commonfile/StudentEnquiryForm'

const TrainerStudentEnquiry = () => {
  return (
   <StudentEnquiryForm/>
  )
}

export default TrainerStudentEnquiry